export default __webpack_public_path__ + "static/media/photo--sm--christina-3.5b6fcc9c.jpg";